import React, { useEffect, useState } from "react";
import { makeGetRequest } from "../../../utils/api";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Card from "react-bootstrap/esm/Card";
import {
  Moon,
  Sun,
  ThermometerHigh,
  ThermometerLow,
} from "react-bootstrap-icons";

function WeatherWeek() {
  const [_lon, _setLon] = useState();
  const [_lat, _setLat] = useState();
  const [location, setLocation] = useState();
  const [weather, setWeather] = useState();

  useEffect(() => {
    if ("geolocation" in navigator) {
      console.log("geolocation services are active");
      navigator.geolocation.getCurrentPosition(
        function (position) {
          _setLat(position.coords.latitude);
          _setLon(position.coords.longitude);
        },
        function (error) {
          console.error("Error Code = " + error.code + " - " + error.message);
        }
      );
    } else {
      console.log("geolocation services are not active");
    }
  }, []);

  useEffect(() => {
    if (_lat) {
      getWeatherData();
    }
  }, [_lat]);

  const getWeatherData = async () => {
    const response = await makeGetRequest(
      "https://api.weather.gov/points/" + _lat + "," + _lon,
      null,
      false
    );
    const weatherInArea = await makeGetRequest(
      response.data.properties.forecast,
      null,
      false
    );
    console.log(weatherInArea);
    setLocation(response.data.properties.relativeLocation.properties);
    setWeather(weatherInArea.data.properties.periods);
  };

  return (
    <div>
      {weather && (
        <Row style={{ padding: 20, marginTop: "25px" }}>
          {weather.map((day, x) => {
            if (x % 2 === 0) {
              return (
                <Card
                  style={{
                    width: "18rem",
                    textAlign: "center",
                    margin: "5px",
                    borderRadius: "25px",
                    boxShadow: "#0000009e 1px 1px 10px 0px",
                    color: "#efefef",
                    backgroundColor: "#1089ff",
                  }}
                >
                  <Card.Body>
                    <Card.Title style={{ borderBottom: "1px solid" }}>
                      {day.name}
                    </Card.Title>
                    <Card.Text>
                      <Row>
                        <Col
                          style={{
                            borderLeft: "1px solid",
                            borderRight: "1px solid",
                            borderTop: "1px solid",
                          }}
                        >
                          <Sun /> <br /> {day.shortForecast}
                        </Col>
                        <Col
                          style={{
                            borderLeft: "1px solid",
                            borderRight: "1px solid",
                            borderTop: "1px solid",
                          }}
                        >
                          <Moon /> <br />
                          {weather[x + 1].shortForecast}
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          style={{
                            borderLeft: "1px solid",
                            borderRight: "1px solid",
                            borderBottom: "1px solid",
                          }}
                        >
                          <ThermometerHigh /> {day.temperature}°
                          {day.temperatureUnit}
                        </Col>
                        <Col
                          style={{
                            borderLeft: "1px solid",
                            borderRight: "1px solid",
                            borderBottom: "1px solid",
                          }}
                        >
                          <ThermometerLow />
                          {weather[x + 1].temperature}°
                          {weather[x + 1].temperatureUnit}
                        </Col>
                      </Row>
                    </Card.Text>
                  </Card.Body>
                </Card>
              );
            }
          })}
        </Row>
      )}
    </div>
  );
}

export default WeatherWeek;
